import {Link} from "react-router-dom";
import {ReactComponent as Plus} from "../../assets/svg/plus.svg";
import {ReactComponent as Filter} from "../../assets/svg/filter-funnel-02.svg";
import {ReactComponent as Heart} from "../../assets/svg/heart.svg";
import {ReactComponent as List} from "../../assets/svg/list.svg";
import {ReactComponent as UserCircle} from "../../assets/svg/user-circle.svg";
import {ReactComponent as Users} from "../../assets/svg/users-03.svg";
import {ReactComponent as AlignRight} from "../../assets/svg/align-right-01.svg";
import ImportListing from "../ImportListing";
import {ReactNode} from "react";
import {callLogout} from "../../services/api";
import {setLogged, setUserData} from "../../store/reducers/listingReducer";
import {useDispatch, useSelector} from "react-redux";
import {config} from "../../config";

export const MobileNav = ({close}: { close: () => void }) => {
    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state.listingReducer.userData);
    const logout = async () => {
        await callLogout();
        dispatch(setLogged(false));
        dispatch(setUserData(null));
        close();
        return true;
    };
    return (
        <nav>
            <div
                className="w-screen z-[9999] fixed top-[4.5rem] min-h-screen bg-white flex flex-col justify-between p-4 pr-10 pb-[4.5rem]">
                <div className="">
                    <div>
                        <Link
                            to={"/add-listing"}
                            className="flex items-center text-gray-700 gap-x-3 font-semibold px-3 py-2"
                            onClick={close}
                        >
                            <span>
                                <Plus/>
                            </span>
                            <span>Add Listing</span>
                        </Link>

                        <div onClick={close}>
                            <ImportListing/>
                        </div>
                    </div>

                    <div className="mt-6">
                        <MenuItem
                            close={close}
                            icon={<UserCircle/>}
                            text="Profile"
                            to="/profile"
                        />
                        <MenuItem
                            close={close}
                            icon={<Users/>}
                            text="My Team"
                            to="/my-team"
                        />
                        <MenuItem
                            close={close}
                            icon={<List/>}
                            text="My Team Activity"
                            to="/my-team-activity"
                        />
                        <MenuItem
                            close={close}
                            icon={<Filter/>}
                            text="Manage Leads"
                            to="/manage-leads"
                        />
                        {/* <MenuItem close={close} icon={<Route />} text="Routes" to="/routes" /> */}
                        <MenuItem
                            close={close}
                            icon={<Heart/>}
                            text="Favourite"
                            to="/favourites"
                        />
                    </div>

                    <div className="mt-6">
                        <button
                            className="flex items-center text-gray-700 gap-x-3 font-semibold px-3 py-2"
                            onClick={logout}
                        >
                            <span>
                                <AlignRight/>
                            </span>
                            <span>Log Out</span>
                        </button>
                    </div>
                </div>

                <div className="pb-8">
                    <hr/>
                    <div className="flex items-center gap-x-3 mt-6">
                        <div>
                            <img
                                className="w-10 h-10"
                                src={
                                    userData?.user_profile_filename
                                        ? `${config.apiUrl}profile-picture?public_id=${userData?.public_id}`
                                        : "https://api.dicebear.com/8.x/lorelei/svg"
                                }
                                alt="avatar"
                            />
                        </div>
                        <div className="text-sm">
                            <div className="font-semibold text-gray-700">
                                {userData?.name}
                            </div>
                            <div>{userData?.email}</div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

const MenuItem = ({
                      icon,
                      text,
                      to,
                      close,
                  }: {
    icon: ReactNode;
    to: string;
    text: string;
    close: () => void;
}) => {
    return (
        <div className="px-3 py-2 text-gray-700 font-semibold">
            <Link
                className="flex items-center text-gray-700 gap-x-3"
                to={to}
                onClick={close}
            >
                <span>{icon}</span>
                <span>{text}</span>
            </Link>
        </div>
    );
};
